export default "__VITE_ASSET__CYoliuQm__"